<template>
  <div>
    <v-layout
      mb-3
      pb-2
      class="elevation-4"
      v-for="(son, i) in sons"
      :key="i"
      row
      wrap
      justify-center
      align-center
    >
      <v-flex mt-2 pl-3 xs2 sm3 md2>
        <v-avatar color="indigo">
          <v-icon dark>account_circle</v-icon>
        </v-avatar>
      </v-flex>
      <v-flex mt-2 class="text-xs-center" xs12 sm5 md3>
        <strong>{{ son.full_name }}</strong>
      </v-flex>
      <v-flex mt-2 xs12 sm4 md7 class="pl-4">
        <v-layout justify-center row wrap>
          <!-- <code>
          enrollment_id: {{ enrollment_id }}
          step: {{ son.current_step }}, isExtempEnrollment: {{ isExtempEnrollment }},
          hasExtempAvailable: {{hasExtempAvailable}},
          isExtempGenEnrollment: {{isExtempGenEnrollment}},
          sonHasPortfolio(son.siesa_sucursal): {{ sonHasPortfolio(son.siesa_sucursal) }},
          sonHasAccess(son.id): {{ sonHasAccess(son.id) }},
          sonAccess(son.id): {{ sonAccess(son.id) }},
          yearly_payment: {{ yearly_payment }},
          extempDetail: {{ extempDetail }},
          enrollment_id: {{ enrollment_id }},
          system_access: {{ system_access }},
          son.next_grade: {{ son.next_grade }}
          </code> -->
          <div v-if="son.current_step == 0">
            <v-btn
              :disabled="
                enrollment_id == null ||
                  son.enroll_status > 0 ||
                  son.next_grade == 99 ||
                  parseInt(son.next_grade, 10) < -1 ||
                  parseInt(son.next_school_id, 10) == 14000 ||
                  (isExtempEnrollment &&
                    !hasExtempAvailable &&
                    !isExtempGenEnrollment) ||
                  sonHasPortfolio(son.siesa_sucursal) ||
                  !sonHasAccess(son.id)
              "
              color="primary"
              @click="nextStep(0, son.full_name, son.id, son.next_grade, false)"
            >
              <span v-if="son.next_grade == 99">{{
                $t(`enrollments.not_available`)
              }}</span>
              <span
                v-else-if="
                  parseInt(son.next_grade, 10) < -1 ||
                    parseInt(son.next_school_id, 10) == 14000
                "
                >{{ $t(`enrollments.admissions`) }}</span
              >
              <span v-else
                >{{ $t(`enrollments.enroll`) }} {{ $t(`enrollments.grade`) }}
                {{ son.next_grade }}</span
              >
            </v-btn>
            <!-- <v-btn v-if="!system_access || son.next_grade == 99" color="primary" @click="nextStep(allyStep, son.full_name, son.id, 0, false)" >Ver aliados</v-btn> -->
          </div>

          <div v-else-if="son.current_step > 0">
            <v-btn
              color="primary"
              :disabled="!sonHasAccess(son.id)"
              @click="
                nextStep(son.current_step, son.full_name, son.id, 0, false)
              "
              >{{ $t(`enrollments.go_to_step`) }} {{ son.current_step }}</v-btn
            >
            <!-- <v-btn v-if="!system_access" color="primary" @click="nextStep(allyStep, son.full_name, son.id, 0, false)" >Ver aliados</v-btn> -->
          </div>

          <div v-else-if="son.current_step == 'fin'">
            <v-dialog
              v-if="enrollmentSurvey.is_enrollment"
              v-model="LastsurveyDialog"
              width="800px"
            >
              <v-card class="mb-5">
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm6 ma-3>
                    <!-- <h1>{{ enrollmentSurvey.id }}</h1> -->
                    <survey-run
                      :surveyId="enrollmentSurvey.id"
                      :cancel="true"
                      :studentId="student_id"
                      externalApp="ENROLLMENTS"
                      :externalAppId="enrollment_id"
                      :externalAppProcessId="enrollmentStatusId"
                      v-on:finished="finished"
                      />
                      <!-- :externalAppProcessId="6350" -->
                  </v-flex>
                </v-layout>
                <!-- <v-layout row justify-center mt-3>
                  <v-btn
                    color="primary"
                    @click="LastsurveyDialog = false;"
                  >
                    Cancelar
                  </v-btn>
                </v-layout> -->
              </v-card>
            </v-dialog>
            <v-btn color="success" depressed>{{
              $t(`enrollments.completed`)
            }}</v-btn>
            <v-btn
              v-if="yearly_payment"
              color="accent"
              @click="
                son.yearly_payment_id && son.yearly_payment_status == 'APPROVED'
                  ? void 0
                  : nextStep(yearlyStep, son.full_name, son.id, 0, false)
              "
              >{{
                son.yearly_payment_id && son.yearly_payment_status == "APPROVED"
                  ? $t(`enrollments.paid_annuity`)
                  : $t(`enrollments.pay_annuity`)
              }}</v-btn
            >
            <v-btn
              color="primary"
              @click="nextStep(allyStep, son.full_name, son.id, 0, false)"
              >{{ $t(`enrollments.go_to_allies`) }}</v-btn
            >
          </div>
        </v-layout>
      </v-flex>
      <v-flex v-if="!sonHasAccess(son.id) && sonAccess(son.id)" xs12 md12>
        <v-alert
          :value="true"
          color="info"
          icon="info"
          class="py-2 text-xs-center"
        >
          <h3>
            {{ $t(`enrollments.extemp_text`) }} {{ $t(`enrollments.from`) }}
            {{ sonAccess(son.id).start_date }} {{ $t(`enrollments.to`) }}
            {{ sonAccess(son.id).finish_date }}.
          </h3>
        </v-alert>
      </v-flex>
      <v-flex v-if="sonHasPortfolio(son.siesa_sucursal)" xs12 md12 my-2>
        <center>
          <v-btn color="info">
            <v-icon>info</v-icon>
            &nbsp;
            {{ $t(`enrollments.accounts_receivable`) }}
          </v-btn>
        </center>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t(`enrollments.same_grade`)
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="execNextStep">
            Si
          </v-btn>

          <v-btn color="success" @click="dialog = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import surveyRun from "./../surveys/run/run.vue";
import axios from "axios";
export default {
  name: "enrollment-step-1",
  components: {
    "survey-run": surveyRun
  },
  props: {
    enrollmentSurvey: {
      type: Object,
      default: {}
    },
    system_access: {
      type: Boolean,
      default: false
    },
    allyStep: {
      type: Number,
      default: 7
    },
    yearlyStep: {
      type: Number,
      default: 8
    },
    hasSurvey: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enrollmentStatusId: '',
      LastsurveyDialog: true,
      dialog: false,
      step: 0,
      son_name_complete: "",
      student_id: 0,
      sonNextGrade: 0,
      idPago: false,
      urlPayment: "",
      urlStep: "",
      urlStudentId: ""
    };
  },
  created() {
    const idPago = this.$route.query.idPago;
    const urlPayment = this.$route.query.payment;
    const urlStep = this.$route.query.step;
    const urlStudentId = this.$route.query.stdi;
    this.idPago = idPago;
    this.urlPayment = urlPayment;
    this.urlStep = urlStep;
    this.urlStudentId = urlStudentId;

    this.init();
  },
  computed: {
    ...mapGetters({
      enrollment_id: "currentEnrollmentId",
      sons: "currentEnrollmentSons",
      isExtempEnrollment: "isExtempEnrollment",
      isExtempGenEnrollment: "isExtempGenEnrollment",
      extempDetail: "extempDetail",
      familyPortfolio: "familyPortfolio",
      yearly_payment: "yearly_payment",
      studentsAccess: "studentsAccess"
    }),
    hasExtempAvailable() {
      let available = false;
      if (this.isExtempEnrollment) {
        available =
          this.extempDetail.filter(extemp => !extemp.enrollment_status_id)
            .length > 0;
      }
      return available;
    },
    extempAvailable() {
      let available_id = 0;
      if (this.isExtempEnrollment) {
        console.log("this.isExtempEnrollment", this.isExtempEnrollment);
        const available = this.extempDetail.find(
          extemp => !extemp.enrollment_status_id
        );
        if (available) {
          available_id = available.extemporaneous_id;
        }
      }
      return available_id;
    }
  },

  methods: {
    finished(){
      this.LastsurveyDialog = false; 
    },
    goToNextStep(step) {
      this.$emit("goToNextStep", step);
    },
    init() {
      this.$store
        .dispatch("fetchSons", { enrollment_id: this.enrollment_id })
        .then(() => {
          this.student_id = this.sons[0].id;
          if (this.idPago) {
            const sonToGoEnrr = this.sons.filter(
              son => son.payment_id == this.idPago
            );
            if (
              sonToGoEnrr &&
              sonToGoEnrr.length > 0 &&
              sonToGoEnrr.current_step !== "fin"
              ) {
              this.step = 4;
              this.student_id = sonToGoEnrr[0].id;
              this.execNextStep();
              return;
            }
            const sonToGoYear = this.sons.filter(
              son => son.yearly_payment_id == this.idPago
              );
            if (sonToGoYear && sonToGoYear.length > 0) {
              this.step = this.yearlyStep;
              this.student_id = sonToGoYear[0].id;
              this.execNextStep();
              return;
            }
          } else if (this.urlPayment === "wompi") {
            this.step = this.urlStep;
            this.student_id = this.urlStudentId;
            this.execNextStep();
          }
          this.getEnrollmentStatus();
        });
    },
    getEnrollmentStatus() {
      axios
        .get(`api/enrollment/status/${this.enrollment_id}/${this.student_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.enrollmentStatusId = resp.data;
          }
        })
        .catch(error => console.log(error));
    },
    nextStep(step, sonFullName, sonId, sonNextGrade, validate) {
      this.step = step;
      this.son_name_complete = sonFullName;
      this.student_id = sonId;
      this.sonNextGrade = sonNextGrade;
      if (validate) {
        this.dialog = true;
        return;
      }
      this.execNextStep();
    },
    execNextStep() {
      this.dialog = false;
      let next_step = this.step;
      const payload = {
        enrollment_id: this.enrollment_id,
        student_id: this.student_id,
        student_grade_enrollment: this.sonNextGrade,
        current_step: 2,
        isExtempEnrollment: this.isExtempEnrollment,
        extempAvailable: this.extempAvailable
      };
      if (this.step === 0) {
        next_step = 2;
        this.$store.dispatch("createEnrollment", payload);
        let textMessage = this.$t(`enrollments.seven_steps`);
        if (!this.hasSurvey) {
          textMessage = this.$t(`enrollments.six_steps`);
        }
        this.$store.dispatch("responseMessage", {
          type: "success",
          title: this.$t(`enrollments.enroll_process`),
          text: textMessage,
          modal: true
        });
      } else {
        this.$store.dispatch("fetchEnrollmentStatus", payload);
      }
      this.$store.dispatch("fetchSiesaReceipts", payload);
      this.goToNextStep(next_step);
    },
    sonHasPortfolio(sucursal) {
      try {
        return !!this.familyPortfolio.find(
          portfolio => portfolio.sucursal == sucursal
        );
      } catch (error) {
        return false;
      }
    },
    sonHasAccess(student_id) {
      try {
        const student_access = this.studentsAccess.find(
          access => access.student_id === student_id && access.enrollment_id == this.enrollment_id
        );
        if (this.system_access && !student_access) {
          return true;
        }
        if (!this.system_access && !student_access) {
          return false;
        }
        if (student_access.system_access) {
          return true;
        } else {
          const start_date = moment(student_access.start_date, "YYYY-MM-DD");
          const end_date = moment(student_access.finish_date, "YYYY-MM-DD");
          if (moment().isBetween(start_date, end_date, "day", "[]")) {
            return true;
          }
        }
        return false;
      } catch (error) {
        return false;
      }
    },
    sonAccess(student_id) {
      try {
        const student_access = this.studentsAccess.find(
          access => access.student_id === student_id
        );
        if (student_access.system_access == 0) {
          return student_access;
        }
        return false;
      } catch (error) {
        return false;
      }
    }
  }
};
</script>

<style>
.table-cell {
  padding: 15px;
  width: 20vw;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step1.vue